export default "__VITE_ASSET__dfe12550__"